import device from './device'

export default {
  // Give a video element sources based on the type of screen
  setVideoSources (videoElement) {
    if (videoElement) {
      const deviceType = device.getDeviceType()
      const webmSource = videoElement.getAttribute(
        `data-source-${deviceType}-webm`
      )
      const mp4Source = videoElement.getAttribute(
        `data-source-${deviceType}-mp4`
      )

      this.addSource(videoElement, webmSource)
      this.addSource(videoElement, mp4Source)
    } else {
      console.error('helpers/video.js - setVideoSources() - Video element not found!')
    }
  },

  // Add <source> tag to video element
  addSource (element, src) {
    if (src) {
      const source = document.createElement('source')
      source.src = src
      // Get video extension w/o query params
      source.type = `video/${src.match(/(webm|mp4|mov)/)[0]}`
      element.appendChild(source)
    }
  }
}
